import { render, staticRenderFns } from "./ViewConsent.vue?vue&type=template&id=3d15647c&"
import script from "./ViewConsent.vue?vue&type=script&lang=js&"
export * from "./ViewConsent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports